export const RCS_STATUS_AVAILABLE = 'AVAILABLE';
export const RCS_STATUS_ACCEPTED = 'ACCEPTED';
export const RCS_STATUS_DECLINED = 'DECLINED';
export const RCS_STATUS_TIMED_OUT = 'TIMED_OUT';
export const RCS_TIMEOUT = 60;
